<template>
  <div class="font-semibold text-center md:text-justify">
    <span class="uppercase font-semibold text-2xl">{{ $t('experience') }}</span>
    <h3 class="mt-2 text-xl">{{ $t('enterPreis') }} ({{ $t('jobDate') }})</h3>
    <br>
    <p class="italic">{{ $t('job') }}</p>
    <p class="text-sm">{{ $t('jobDesc') }}</p>
    <br>
    <p class="italic">{{ $t('mentoring') }}</p>
    <p class="text-sm">{{ $t('mentoringDesc') }}</p>
  </div>
</template>
